// Admin-fane: oversikt over hvem som har skrudd gruppe-chat av/på (investor + låntaker).
import { Loader2 } from "lucide-react";

import { useGroupOptIn } from "../api/groupOptin";
import { Initials } from "./AdminUI";

export function GroupOptInTab() {
  const { data, isLoading, isError } = useGroupOptIn();

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 py-8 text-sm text-white/50">
        <Loader2 className="size-4 animate-spin" /> Laster…
      </div>
    );
  }
  if (isError) return <div className="py-8 text-sm text-red-300">Kunne ikke laste opt-in-status.</div>;

  const rows = data ?? [];
  const on = rows.filter((r) => r.optIn).length;

  return (
    <div>
      <p className="mb-4 text-sm text-white/55">
        <span className="font-semibold text-teal-300">{on}</span> av {rows.length} har skrudd
        gruppe-chat <span className="text-teal-200">på</span>.
      </p>
      <div className="overflow-x-auto rounded-xl border border-white/10">
        <table className="w-full min-w-[640px] text-left text-sm">
          <thead>
            <tr className="border-b border-white/10 text-xs uppercase tracking-wider text-white/40">
              <th className="px-4 py-3 font-medium">Navn</th>
              <th className="px-4 py-3 font-medium">E-post</th>
              <th className="px-4 py-3 font-medium">Rolle</th>
              <th className="px-4 py-3 text-right font-medium">Gruppe-chat</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5">
            {rows.length === 0 ? (
              <tr>
                <td colSpan={4} className="px-4 py-6 text-center text-white/40">
                  Ingen registrerte kontoer.
                </td>
              </tr>
            ) : (
              rows.map((r) => (
                <tr key={r.accountId} className="transition-colors hover:bg-white/[0.04]">
                  <td className="px-4 py-2.5">
                    <div className="flex items-center gap-3">
                      <Initials name={r.name} fallback={r.email} />
                      <span className="font-medium text-white">{r.name ?? "—"}</span>
                    </div>
                  </td>
                  <td className="px-4 py-2.5 text-white/60">{r.email}</td>
                  <td className="px-4 py-2.5 text-white/70">
                    {r.role === "loaner" ? "Låntaker" : "Långiver"}
                  </td>
                  <td className="px-4 py-2.5 text-right">
                    <span
                      className={
                        r.optIn
                          ? "inline-flex items-center rounded-full bg-emerald-500/15 px-2.5 py-0.5 text-xs font-medium text-emerald-300 ring-1 ring-inset ring-emerald-500/30"
                          : "inline-flex items-center rounded-full bg-white/5 px-2.5 py-0.5 text-xs font-medium text-white/40 ring-1 ring-inset ring-white/10"
                      }
                    >
                      {r.optIn ? "På" : "Av"}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
